import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/cms/v1`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lineRichMenuApi = {
  getItems: (pageId, params) => instance().get(`/page/${pageId}/line-rich-menu`, { params })
}

export default lineRichMenuApi



// WEBPACK FOOTER //
// ./src/api/line-rich-menu.js